"use client"

import { SaveOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SaveOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SaveOffIcon = component(Icon)({ as: SaveOff })
